/**
 *  Header JS
 *  Search Helper
 *  Navigation 2nd level Close Helper
 */

class Header {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        const searchTrigger = this.elem.querySelector('#search-trigger');
        const searchField = this.elem.querySelector('.search-field');
        const dropdownTrigger = document.getElementsByClassName("js-menu-trigger");
        const header = document.querySelector('.header');
        const hero = document.querySelector('.hero-container');
        const headerHeight = 140;

        $('.navigation__sub-menu').each((index, element) => {
            setTimeout(() => { element.style.display = 'block' }, 10);
        });

        //If Search Symbol in Header is clicked, set focus to search field
        searchTrigger.addEventListener("click", function() {
            searchField.focus();
        });

        // On UnFocus SearchField, uncheck checkbox if clickedElement is not Trigger Checkbox
        searchField.addEventListener("focusout", function(unFocusElement) {
            if(!unFocusElement.relatedTarget) {
                searchTrigger.checked = false;
            }
        });

        // Watch and close Subnavigation when click-event is outside subnavigation
        document.addEventListener('click', function (clickedElement) {
             if (!clickedElement.target.classList.contains('js-menu-trigger')) {
                if ((clickedElement.target).closest('.navigation__sub-menu') === null) {
                    for (let i = 0; i < dropdownTrigger.length; i += 1) {
                        dropdownTrigger[i].checked = false;
                    }
                }
             } else {
                 for (let i = 0; i < dropdownTrigger.length; i += 1) {
                     if(dropdownTrigger[i].checked) {
                         if(dropdownTrigger[i] !== clickedElement.target) {
                             console.log(clickedElement.target);
                             dropdownTrigger[i].checked = false;
                         }
                     }
                 }
             }
        });


        // If Hero exist, animate header
        if(hero) {
            window.addEventListener('scroll', () => {
                const scrollPosition = window.scrollY;

                if(scrollPosition < headerHeight) {
                    header.classList.remove('header--white');
                } else {
                    header.classList.add('header--white');
                }
            });
        }
    }
}

export default Header;
